import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CardActionArea, CardActions, Button, Typography, Card, CardContent, CardMedia } from '@material-ui/core';
import GitHubIcon from '@material-ui/icons/GitHub';
import LiveTvIcon from '@material-ui/icons/LiveTv';

// background-color: teal;
// background-color: darkslategrey;
//Css Style
const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
        margin: '2rem 1rem 0 1rem'
    },
    media: {
        height: 140,
    },
    ml: {
        marginLeft: 'auto!important'
    },
    actionLink: {
        marginLeft: '.5rem!important',
        color:'tan'
    },
    iconColor: {
        color:'tomato'
    },
    cardContent: {
        backgroundColor:'teal',
        color:'white',
        height:'200px'
    },
    cardFooter: {
        backgroundColor:'darkslategrey'
    },
   
}));

const CardItem = (props) => {
    const {img, title, description, github, website} = props.pdata;
    const classes = useStyles();
    return (
        <>
            <Card className={classes.root} >
                <CardActionArea>
                    <CardMedia
                        className={classes.media}
                        image={img}
                        title="Contemplative Reptile"
                    />
                    <CardContent className={classes.cardContent}>
                        <Typography gutterBottom variant="h5" component="h2">
                            {title}
                           </Typography>
                        <Typography variant="body1" className={classes.bodyHight} color="textSecondary" component="p">
                            {description}
                            </Typography>
                    </CardContent>
                </CardActionArea>
                <CardActions className={classes.cardFooter}>
                    <a target="_blan" href={github}>
                        <Button size="small" color="primary">   
                                <GitHubIcon className={classes.iconColor} />
                            <Typography className={classes.actionLink}>Github</Typography> 
                        </Button>
                    </a>

                    <a target="_blan" href={website}>
                        <Button className={classes.ml} size="small" color="primary">
                                <LiveTvIcon className={classes.iconColor}/>
                            <Typography className={classes.actionLink}>Live</Typography>     
                        </Button>
                    </a>

                </CardActions>
            </Card>
        </>
    );
};

export default CardItem;